import Seo from "../components/Seo";
import { SectionHead, CTABand, NetworkNote } from "../components/bits";
import { BluetoothFlow, CellularFlow, DecisionGraphic } from "../components/diagrams";
import { HOW_IT_WORKS } from "../content/pages";

function StepList({ steps, prefix }) {
  return (
    <ol className="mt-10 space-y-6">
      {steps.map((s, i) => (
        <li key={s.title} className="flex gap-5" data-testid={`${prefix}-step-${i + 1}`}>
          <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-sm border border-primary/40 bg-white font-mono text-sm font-semibold text-primary">
            {i + 1}
          </span>
          <div>
            <h3 className="text-base font-semibold text-brand-navy">{s.title}</h3>
            <p className="mt-1 text-sm leading-relaxed text-brand-slate">{s.body}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}

export default function HowItWorks() {
  return (
    <>
      <Seo
        path="/how-smart-labels-work"
        title="How Smart Labels Work"
        description="How the GNTS1 Bluetooth sticker and LL100 4G smart label each produce a location — detection networks vs onboard GNSS, explained without the marketing fog."
      />
      <section className="border-b border-border bg-brand-surface">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
          <h1 className="max-w-3xl text-4xl font-semibold tracking-tight text-brand-navy sm:text-5xl">How smart labels actually work</h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-brand-slate md:text-lg">{HOW_IT_WORKS.intro}</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl space-y-20 px-4 py-16 sm:px-8">
        <div className="grid items-start gap-10 lg:grid-cols-2" data-testid="hiw-bluetooth">
          <div>
            <SectionHead kicker="Architecture 1" title={HOW_IT_WORKS.bt.title} />
            <StepList steps={HOW_IT_WORKS.bt.steps} prefix="bt" />
            <div className="mt-8"><NetworkNote /></div>
          </div>
          <div className="lg:sticky lg:top-24"><BluetoothFlow /></div>
        </div>

        <div className="grid items-start gap-10 border-t border-border pt-20 lg:grid-cols-2" data-testid="hiw-cellular">
          <div>
            <SectionHead kicker="Architecture 2" title={HOW_IT_WORKS.cell.title} />
            <StepList steps={HOW_IT_WORKS.cell.steps} prefix="cell" />
          </div>
          <div className="lg:sticky lg:top-24"><CellularFlow /></div>
        </div>

        <div className="border-t border-border pt-20" data-testid="hiw-decision">
          <SectionHead kicker="The short version" title="One question does most of the sorting" />
          <div className="mt-10 max-w-3xl"><DecisionGraphic /></div>
        </div>
      </section>

      <CTABand />
    </>
  );
}
